/* eslint-disable @typescript-eslint/no-magic-numbers */
import Vue from 'vue';
import ToastDom from './Toast.vue';

const ToastConstructor = Vue.extend(ToastDom);

export interface IOptions {
  icon?: string;
  type?: string; // toast icon
  value?: any;
  duration?: number; // toast close duration
}

const toastPool: Array<any> = [];
const typeMap: any = {
  error_network: require('./assets/network-err.svg'),
  failure: require('./assets/failure.svg'),
  success: require('./assets/success.svg'),
  warn: require('./assets/warning.svg'),
};

const getAnInstance = () => {
  if (toastPool.length) {
    const instance = toastPool[0];
    toastPool.splice(0, 1);
    return instance;
  }
  return new ToastConstructor({
    el: document.createElement('div'),
  });
};

const returnAnInstance = (instance: any) => {
  if (instance) {
    toastPool.push(instance);
  }
};

const removeDom = (event: any) => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

ToastConstructor.prototype.unset = function() {
  this.toastString = '';
  this.icon = '';
  this.toastType = '';
  this.toastIconType = '';
  this.toastSecondTitle = '';
  this.toastSecondString = '';
};

ToastConstructor.prototype.close = function() {
  this.toastShow = false;
  this.$el.addEventListener('transitionend', removeDom);
  this.closed = true;
  returnAnInstance(this);
};

const Toast = (options: IOptions) => {
  const duration = options.duration || 1500;

  const instance = getAnInstance();
  instance.closed = false;
  instance.unset();
  clearTimeout(instance.timer);
  if (options.type === 'first-level') {
    // 一级文案弹窗
    instance.toastString = options.value;
    instance.toastType = 'first-level';
  } else if (options.type === 'second-level') {
    // 二级文案弹窗
    instance.toastSecondTitle = options.value[0];
    instance.toastSecondString = options.value[1];
    instance.toastType = 'second-level';
  } else {
    // 普通提示弹窗
    instance.toastString = options.value || '';
    instance.icon = options.icon || '';
    if (options.type && !options.icon) {
      instance.icon = typeMap[options.type] || '';
    }
  }
  document.body.appendChild(instance.$el);
  Vue.nextTick(function() {
    instance.toastShow = true;
    instance.$el.removeEventListener('transitionend', removeDom);
    ~duration &&
      (instance.timer = setTimeout(function() {
        if (instance.closed) return;
        instance.close();
      }, duration));
  });
  return instance;
};
export default Toast;
